// Toast „Přidáno do košíku" — náhrada za default mini-cart popup (.user-action),
// který v blank-mode designu skrýváme (_base.scss). Bez něj by jediný feedback po
// addToCart byl badge v headeru. Zobrazí se jen při NÁRŮSTU počtu kusů,
// auto-hide; odkaz na košík bere z a.cart-count (jazykové mutace URL).
import { onCartUpdated, cartState } from '../shoptet-hooks.js';
import { page } from './pages.js';
import L from '../locale/cs/cartToast.js';

const HIDE_AFTER_MS = 4000;

const LABEL_ADDED = L.added;
const LABEL_SHOW_CART = L.showCart;

function itemsCount(cart) {
  if (!cart) return 0;
  if (cart.itemsCount != null) return Number(cart.itemsCount) || 0;
  if (cart.count != null) return Number(cart.count) || 0;
  return 0;
}

export function initCartToast() {
  if (document.body.dataset.bsCartToast) return;
  document.body.dataset.bsCartToast = '1';

  let prev = itemsCount(cartState());
  let hideTimer = null;

  function toastEl() {
    let el = document.querySelector('.bs-cart-toast');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'bs-cart-toast';
    el.setAttribute('role', 'status');
    const cartHref = document.querySelector('a.cart-count')?.getAttribute('href') || page('cart');
    el.innerHTML =
      '<svg class="bs-cart-toast__icon" aria-hidden="true"><use href="#bs-i-check"></use></svg>' +
      '<span class="bs-cart-toast__text">' + LABEL_ADDED + '</span>' +
      '<a class="bs-cart-toast__link" href="' + cartHref + '">' + LABEL_SHOW_CART + '</a>';
    document.body.appendChild(el);
    return el;
  }

  onCartUpdated(function (cart) {
    const count = itemsCount(cart);
    const grew = count > prev;
    prev = count;
    if (!grew) return;
    // Se zapnutým advanced order je feedback po addu modal „Přidáno do košíku"
    // (cartModal.js) — toast by se s ním dubloval. Zůstává jako fallback pro
    // shop s vypnutým popupem.
    if (window.shoptet && window.shoptet.config && window.shoptet.config.showAdvancedOrder) return;

    const el = toastEl();
    el.classList.add('is-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, HIDE_AFTER_MS);
  });
}
